import type { AgentState } from '@takeshape/schema';
import type { AIServiceDefaults } from '../common/llm';

export type CreateAiStateParams = {
  id: string;
  type: 'chat' | 'generate';
  aiDefaults?: AIServiceDefaults;
  defaultInput?: string | undefined;
  includeTransitions?: boolean;
};

export function createAiState(params: CreateAiStateParams): AgentState {
  const { id, type, aiDefaults, defaultInput, includeTransitions = true } = params;
  const result: AgentState = {
    name: type,
    execution: {
      type: type,
      service: aiDefaults?.service ?? '',
      model: aiDefaults?.generateModel ?? '',
      input: {
        type: 'arg'
      },
      systemPrompt: 'You are a helpful assistant.'
    }
  };

  if (defaultInput && type === 'chat' && includeTransitions) {
    result.transitions = [{ type: 'suspend', destination: id, input: defaultInput }];
  }

  return result;
}
